<template lang="pug">
transition(name="fade")
  .dialog-background(v-show="show" @click.self="maybeHide")
    .dialog
      .dialog-body
        slot(name="body")
      .dialog-footer
        slot(name="footer")
</template>

<script>
export default {
  name: 'RomatchDialog',
  props: {
    show: Boolean,
    isModal: Boolean,
  },
  methods: {
    maybeHide() {
      if (!this.isModal) this.$emit('hide')
    },
  },
}
</script>

<style scoped lang="stylus">
.dialog-background
  position fixed
  top 0
  bottom 0
  left 0
  right 0
  background rgba(0, 0, 0, 0.25)
  display flex
  align-items center
  justify-content center
  z-index 1000

.dialog
  max-width 600px
  border-radius 5px
  background white
  padding 2rem 3rem
  box-shadow 0 2px 3px rgba(0, 0, 0, 0.3)

.dialog-body, .dialog-footer
  padding 0.5rem 0
</style>
